import script from "./MyPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPagination.vue?vue&type=script&setup=true&lang=js"

import "./MyPagination.vue?vue&type=style&index=0&id=19a35261&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a35261"]])

export default __exports__